<template>
  <div class="t-flex t-flex-col">
    <div
      class="
        t-flex t-flex-col
        md:t-flex-row md:t-items-end md:t-justify-between
        t-mb-3 t-pb-4 t-border-b-2 t-border-gray-200
      "
    >
      <h3 class="t-text-xl t-font-bold">Current Consignments</h3>

      <div
        class="
          t-flex t-flex-col
          md:t-flex-row
          t-space-y-2
          md:t-space-y-0
          t-justify-end t-items-start
          md:t-items-center
          t-mt-3
          md:t-mt-0
        "
      >
        <div
          v-click-outside="() => (this.showFilters = false)"
          class="t-relative t-inline-block t-mr-4"
        >
          <!--<button @click="test()">Refresh</button>-->
          <button
            @click="() => (this.showFilters = !this.showFilters)"
            class="
              t-w-24
              t-inline-flex
              t-border
              t-border-gray-400
              t-py-1
              t-px-2
              t-text-sm
              t-rounded-md
              t-items-center
              t-justify-between
              t-font-semibold
              t-shadow-sm
            "
          >
            Filter <i class="fas fa-chevron-down t-ml-2" />
          </button>

          <div
            v-show="showFilters"
            class="
              t-origin-top-right
              t-mt-1
              t-absolute
              t-z-10
              t-right-1
              t-border
              t-border-gray-200
              t-rounded-lg
              t-shadow-lg
              t-bg-white
              t-pt-2
              t-px-2
              t-space-y-1
            "
          >
            <div>
              <div class="t-font-medium">Status</div>

              <div class="t-space-x-1 t-px-1">
                <input
                  v-model="filters.status"
                  type="checkbox"
                  class="t-w-4 t-h-4 t-mt-1"
                  value="Booked"
                />
                <label class="t-mb-0 t-text-gray-800 t-text-sm" role="menuitem">
                  Booked
                </label>
              </div>

              <div class="t-space-x-1 t-px-1 t-whitespace-no-wrap">
                <input
                  v-model="filters.status"
                  type="checkbox"
                  class="t-w-4 t-h-4 t-mt-1"
                  value="In Transit"
                />
                <label class="t-mb-0 t-text-gray-800 t-text-sm" role="menuitem">
                  In Transit
                </label>
              </div>
            </div>

            <div>
              <div class="t-font-medium">Pickup From</div>
              <div
                class="
                  t-flex
                  t-items-center
                  t-space-x-1
                  t-my-2
                  t-px-2
                  t-py-1
                  t-border
                  t-border-gray-700
                "
              >
                <i class="fas fa-search" />
                <input
                  v-model="filters.pickupText"
                  type="text"
                  class="focus:t-outline-none"
                  placeholder="Enter a location name"
                />
              </div>
            </div>

            <div class="t-mb-2">
              <div class="t-font-medium">Deliver To</div>
              <div
                class="
                  t-flex
                  t-items-center
                  t-space-x-1
                  t-mt-2
                  t-mb-4
                  t-px-2
                  t-py-1
                  t-border
                  t-border-gray-700
                "
              >
                <i class="fas fa-search" />
                <input
                  v-model="filters.deliverText"
                  type="text"
                  class="focus:t-outline-none"
                  placeholder="Enter a location name"
                />
              </div>
            </div>

            <div
              @click="resetFilters"
              class="
                t-flex
                t-justify-center
                t-font-medium
                t-bg-gray-200
                t-py-1
                t--mx-2
                t--my-2
                t-cursor-pointer
              "
            >
              Reset
            </div>
          </div>
        </div>

        <div
          class="
            t-inline-block t-text-dodger-blue t-text-lg t-px-4 t-cursor-pointer
            hover:t-text-blue-500
          "
        >
          <router-link :to="{ name: 'carrierConsignments' }">
            View All
          </router-link>
        </div>
      </div>
    </div>

    <div class="t-overflow-x-auto">
      <div class="t-align-middle t-inline-block t-min-w-full">
        <div class="carrier-table t-overflow-y-auto">
          <div class="t-flex t-px-3 t-justify-between t-mb-2 t-font-semibold">
            <p class="t-w-28">Status</p>
            <p class="t-w-32 t-px-2">Consignment</p>
            <p class="t-w-40 t-flex t-flex-grow t-px-4">From</p>
            <p class="t-w-40 t-flex t-flex-grow t-px-4">To</p>
            <p class="t-w-36 t-flex t-flex-grow t-px-4">Pickup After</p>
            <p class="t-w-36 t-flex t-flex-grow t-px-4">Deliver By</p>
          </div>

          <div
            v-if="loadingConsignments"
            class="
              t-py-4 t-text-center t-text-2xl t-font-medium t-text-gray-900
            "
          >
            <i class="fas fa-x fa-spinner-third fa-spin"></i>
            Loading
          </div>

          <div
            v-if="!loadingConsignments && consignments.length === 0"
            class="
              t-py-4 t-text-center t-text-2xl t-font-medium t-text-gray-900
            "
          >
            You currently don't have any consignments
          </div>

          <div
            v-if="!loadingConsignments && consignments"
            v-for="consignment of applyFilters(consignments)"
            :key="consignment.id"
            class="
              t-flex
              t-bg-whitesmoke
              t-mb-3
              t-rounded-md
              t-px-3
              t-py-3
              t-justify-between
            "
          >
            <div class="t-w-28" style="position: relative">
              <div class="dropdown" style="margin: 0px 0px 0px 10px">
                <button
                  role="button"
                  type="button"
                  class="btn"
                  :class="[
                    {
                      'btn-error t-bg-red with-full-radius':
                        consignment.status_human === 'Booked' &&
                        (convertPickupAfter(consignment.pickup_after) >
                          currentDate ||
                          consignment.ready_for_pickup === false),
                    },
                    {
                      'btn-warning t-bg-orange with-full-radius':
                        consignment.status_human === 'Booked' &&
                        (convertPickupAfter(consignment.pickup_after) <=
                          currentDate ||
                          consignment.ready_for_pickup === true),
                    },
                    {
                      'btn-info t-bg-dodger-blue with-full-radius':
                        consignment.status_human === 'In Transit',
                    },
                    {
                      'btn-success t-bg-forest-green with-full-radius':
                        consignment.status_human === 'Delivered',
                    },
                  ]"
                  data-toggle="dropdown"
                  :disabled="consignment.status_human === 'Delivered'"
                >
                  {{ consignment.status_human }}
                </button>

                <div class="dropdown-menu">
                  <a
                    v-if="consignment.status_human === 'Booked'"
                    class="dropdown-item"
                    @click="setNewStatus('In Transit', consignment.id)"
                    ><i class="fa fa-square" style="color: blue"></i>In
                    Transit</a
                  >
                  <a
                    v-if="
                      consignment.status_human === 'Booked' ||
                      consignment.status_human === 'In Transit'
                    "
                    class="dropdown-item"
                    @click="setNewStatus('Delivered', consignment.id)"
                    ><i class="fa fa-square" style="color: green"></i
                    >Delivered</a
                  >
                  <a
                    v-if="
                      consignment.status_human !== 'Booked' ||
                      consignment.status_human !== 'Delivered'
                    "
                    class="dropdown-item"
                    @click="setNewETA('ETA', consignment.id)"
                    style="font-size: 10px; font-style: italic"
                    ><i class="fa fa-square" style="color: yellow"></i>
                    (Update ETA)
                  </a>
                </div>
              </div>
              <div
                :id="'date_time_' + consignment.id"
                class="date-time"
                style="
                  position: absolute;
                  top: 40px;
                  left: 12px;
                  background: #fff;
                  border: 1px solid #ccc;
                  padding: 10px;
                  z-index: 10000;
                  visibility: hidden;
                "
              >
                <h2 style="margin-bottom: 10px" v-if="newStatus != 'ETA'">
                  SELECT DATE AND TIME 
                  {{
                    consignment.status_human === "Booked"
                      ? "PICKED UP"
                      : "DELIVERED"
                  }}
                </h2>
                <h2 style="margin-bottom: 10px" v-if="newStatus == 'ETA'">
                  CHANGE DELIVERY ETA DATE AND TIME
                </h2>
                <div class="t-flex">
                  <v-date-picker v-model="statusDate" mode="dateTime" />
                  <div style="flex-direction: column; padding-left: 10px">
                    <button
                      class="btn btn-primary"
                      style="width: 100%; margin-bottom: 10px"
                      @click="updateStatusWithDate(consignment.id)"
                      v-if="newStatus != 'ETA'"
                    >
                      Update
                    </button>
                    <button
                      class="btn btn-success"
                      style="width: 100%; margin-bottom: 10px"
                      @click="updateETAWithDate(consignment.id)"
                      v-if="newStatus == 'ETA'"
                      :disabled="isDisabled"
                    >
                      Update
                    </button>
                    <button
                      class="btn btn-danger"
                      style="width: 100%; margin-bottom: 10px"
                      @click="updateClose()"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                <div v-if="newStatus == 'ETA'">
                  <h2 style="margin: 10px 0px 0px 0px">REASON</h2>
                  <span
                    style="font-size: 10px"
                    :class="[
                      {
                        'text-error': hasError,
                      },
                    ]"
                    >Please provide commentary as to why delivery ETA has
                    changed</span
                  >
                  <input
                    type="text"
                    name="reason"
                    class="form-control"
                    v-model="reason"
                  />
                </div>
              </div>
            </div>
            <div
              class="
                t-w-32 t-px-2 t-text-lg t-text-dodger-blue t-cursor-pointer
                hover:t-text-blue-500
              "
            >
              <a :href="'/carry-freight/bookings/' + consignment.id">
                {{ consignment.number }}
              </a>
            </div>
            <div class="t-w-40 t-flex t-flex-col t-flex-grow t-px-4">
              <a-popover placement="top">
                <template>
                  <span>{{ consignment.pickup_location.name }}</span>
                </template>
                <template slot="content">
                  <div class="t-flex t-flex-col">
                    <span>
                      <i class="fa fa-map-marker" aria-hidden="true" />
                      <span
                        v-if="consignment.pickup_location.address.formatted"
                      >
                        {{ consignment.pickup_location.address.formatted }}
                      </span>
                      <span v-else>
                        {{ consignment.pickup_location.address.street_number }}
                        {{ consignment.pickup_location.address.street_name }},
                        {{ consignment.pickup_location.address.suburb }},
                        {{ consignment.pickup_location.address.city }}
                        {{ consignment.pickup_location.address.region }}
                      </span>
                    </span>
                    <span>
                      <i class="fa fa-user" aria-hidden="true" />
                      <span>{{
                        consignment.pickup_location.contact_name
                      }}</span>
                    </span>
                    <span v-if="consignment.pickup_location.email">
                      <i class="fa fa-envelope" aria-hidden="true" />
                      <span>{{ consignment.pickup_location.email }}</span>
                    </span>
                    <span v-if="consignment.pickup_location.phone">
                      <i class="fa fa-phone" aria-hidden="true" />
                      <span>{{ consignment.pickup_location.phone }}</span>
                    </span>
                  </div>
                </template>
              </a-popover>

              <div
                class="t-flex t-flex-wrap t-w-12 t-py-3 t-space-x-1"
                v-if="
                  consignment.contains_dgs ||
                  consignment.pickup_requires_taillift
                "
              >
                <!-- Dangerous Goods Icon -->
                <a-popover v-if="consignment.contains_dgs">
                  <template slot="content">
                    <span>Contains Dangerous Goods</span>
                  </template>
                  <icon-font-cn type="iconskeleton" class="t-mt-1" />
                </a-popover>

                <!-- TailLift Icon -->
                <a-popover
                  placement="top"
                  v-if="consignment.pickup_requires_taillift"
                >
                  <template slot="content">
                    <span>Requires a tail lift</span>
                  </template>
                  <tail-lift-icon class="t-flex t-w-4 t-h-4 t-mt-1" />
                </a-popover>
              </div>
            </div>
            <div class="t-w-40 t-flex t-flex-col t-flex-grow t-px-4">
              <a-popover placement="top">
                <template>
                  <span>{{ consignment.delivery_location.name }}</span>
                </template>
                <template slot="content">
                  <div class="t-flex t-flex-col">
                    <span>
                      <i class="fa fa-map-marker" aria-hidden="true" />
                      <span
                        v-if="consignment.delivery_location.address.formatted"
                      >
                        {{ consignment.delivery_location.address.formatted }}
                      </span>
                      <span v-else>
                        {{
                          consignment.delivery_location.address.street_number
                        }}
                        {{ consignment.delivery_location.address.street_name }},
                        {{ consignment.delivery_location.address.suburb }},
                        {{ consignment.delivery_location.address.city }}
                        {{ consignment.delivery_location.address.region }}
                      </span>
                    </span>
                    <span>
                      <i class="fa fa-user" aria-hidden="true" />
                      <span>{{
                        consignment.delivery_location.contact_name
                      }}</span>
                    </span>
                    <span v-if="consignment.delivery_location.email">
                      <i class="fa fa-envelope" aria-hidden="true" />
                      <span>{{ consignment.delivery_location.email }}</span>
                    </span>
                    <span v-if="consignment.delivery_location.phone">
                      <i class="fa fa-phone" aria-hidden="true" />
                      <span>{{ consignment.delivery_location.phone }}</span>
                    </span>
                  </div>
                </template>
              </a-popover>

              <!-- TailLift Icon -->
              <a-popover
                placement="top"
                v-if="consignment.delivery_requires_taillift"
              >
                <template slot="content">
                  <span>Requires a tail lift</span>
                </template>
                <tail-lift-icon class="t-flex t-w-4 t-h-4 t-mt-1" />
              </a-popover>
            </div>
            <div class="t-w-36 t-flex t-flex-grow t-px-4">
              <div v-if="consignment.pickup_before">
                <p>
                  <span class="t-font-medium">Pickup After</span>
                  {{
                    moment(consignment.pickup_after)
                      .local()
                      .format("hh:mm A ddd DD MMM")
                  }}
                </p>
                <p>
                  <span class="t-font-medium">Pickup Before</span>
                  {{
                    moment(consignment.pickup_before)
                      .local()
                      .format("hh:mm A ddd DD MMM")
                  }}
                </p>
              </div>
              <div v-else>
                <p>
                  {{
                    moment(consignment.pickup_after)
                      .local()
                      .format("hh:mm A ddd DD MMM")
                  }}
                </p>
              </div>
            </div>
            <div class="t-w-36 t-flex t-flex-col t-flex-grow t-px-4">
              {{
                consignment.deliver_before &&
                moment(consignment.deliver_before)
                  .local()
                  .format("hh:mm A ddd DD MMM")
              }}
              <!-- Consignment Red Clock -->
              <a-popover placement="topLeft" v-if="consignment.red_clock !== 0">
                <template slot="content">
                  <span>
                    Behind the schedule, please
                    <a href="/contact" target="_blank"> contact Freighthub</a>
                    for more details
                  </span>
                </template>

                <div style="color: red">
                  <span
                    ><i class="fa fa-clock" aria-hidden="true" /> +{{
                      consignment.red_clock
                    }}</span
                  >
                </div>
              </a-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * TODO: Clean up how sort and filters work
 */

import moment from "moment";
import { LOAD_DASHBOARD_CONSIGNMENTS } from "../../../../modules/consignments";
import TailLiftIcon from "../../../icons/TailLiftIcon";
import IconFontCn from "../../../icons/IconFontCn";

export default {
  name: "DashboardCarrierLegsTable",
  description: "",
  components: {
    TailLiftIcon,
    IconFontCn,
  },
  data() {
    return {
      filters: {
        status: ["Booked", "In Transit"],
        pickupText: "",
        deliverText: "",
      },
      selectedSortText: "Latest Pickup Time",
      showSortOptions: false,
      showFilters: false,
      moment,
      currentDate: moment().format("YYYY-MM-DD HH:mm"),
      statusDate: moment().format("YYYY-MM-DD HH:mm"),
      newStatus: null,
      showDate: false,
      reason: null,
      hasError: false,
      isDisabled: false,
    };
  },
  computed: {
    consignments() {
      return this.$store.getters.dashboardConsignments;
    },
    loadingConsignments() {
      return this.$store.getters.loadingDashboardConsignments;
    },
  },
  created() {
    this.$store.dispatch(LOAD_DASHBOARD_CONSIGNMENTS);
  },
  methods: {
    test() {
      this.$store.dispatch(LOAD_DASHBOARD_CONSIGNMENTS);
    },
    convertPickupAfter(pickupAfter) {
      return moment(pickupAfter).format("YYYY-MM-DD HH:mm");
    },
    sortLatestPickup(bookings) {
      if (typeof bookings != "undefined") {
        return bookings.sort(
          (a, b) => new Date(b.pickup_after) - new Date(a.pickup_after)
        );
      }
    },
    sortEarliestPickup() {
      if (typeof this.bookings != "undefined") {
        this.bookings = this.bookings.sort(
          (a, b) => new Date(a.pickup_after) - new Date(b.pickup_after)
        );
      }
    },
    applyFilters(consignments) {
      if (!consignments) {
        return;
      }

      let filteredConsignments = consignments;

      let pickupText = this.filters.pickupText.toLowerCase();
      if (pickupText.length > 0) {
        filteredConsignments = filteredConsignments.filter((c) =>
          c.pickup_location.name.toLowerCase().includes(pickupText)
        );
      }

      let deliverText = this.filters.deliverText.toLowerCase();
      if (deliverText.length > 0) {
        filteredConsignments = filteredConsignments.filter((c) =>
          c.delivery_location.name.toLowerCase().includes(deliverText)
        );
      }

      filteredConsignments = filteredConsignments.filter((c) => {
        for (let status of this.filters.status) {
          if (c.status_human.toLowerCase().includes(status.toLowerCase())) {
            return true;
          }
        }
        return false;
      });

      return filteredConsignments;
    },
    resetFilters() {
      this.filters = {
        status: ["Assigned", "Picked up"],
        pickupText: "",
        deliverText: "",
      };
      this.sortLatestPickup();
      this.selectedSortText = "Latest Pickup Time";
    },
    setNewStatus(status, id) {
      this.newStatus = status;
      this.closeAllDateTime();

      document.getElementById("date_time_" + id).style.visibility = "visible";
    },
    setNewETA(status, id) {
      this.newStatus = status;
      this.closeAllDateTime();

      document.getElementById("date_time_" + id).style.visibility = "visible";
    },
    updateStatusWithDate(id) {
      switch (this.newStatus) {
        case "In Transit":
          this.updatePickedUp(id);
          break;

        case "Delivered":
          this.updateDelivered(id);
          break;

        case "Cancel":
          this.updateCancel(id);
          break;
      }
    },
    updateETAWithDate(id) {
      this.isDisabled = true;

      if (!this.reason) {
        this.hasError = true;
        this.isDisabled = false;
      } else {
        this.hasError = false;
      }

      if (!this.hasError) this.updateETA(id);
    },
    updateClose() {
      this.hasError = false;
      this.closeAllDateTime();
    },
    closeAllDateTime() {
      var list, index;
      list = document.getElementsByClassName("date-time");
      for (index = 0; index < list.length; ++index) {
        document.getElementById(list[index].id).style.visibility = "hidden";
      }
    },
    updatePickedUp(id) {
      let dateTime = moment(this.statusDate, "YYYY-MM-DD HH:mm");
      let dateTimeString = dateTime.format("ddd D MMM gggg h A");
      let updateTime =
        dateTimeString === "Invalid date"
          ? moment().format("ddd D MMM gggg h A")
          : dateTimeString;

      axios
        .put("/carry-freight/bookings/" + id + "/pickup", {
          update_time: updateTime,
        })
        .then((response) => {
          let data = response.data;

          if (data.is_success) {
            this.$swal({
              title: data.message,
              type: "success",
            });

            this.$store.dispatch(LOAD_DASHBOARD_CONSIGNMENTS);
          } else {
            this.$swal({
              title: data.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          Event.$emit("serverError");
        });
    },
    updateDelivered(id) {
      let dateTime = moment(this.statusDate, "YYYY-MM-DD HH:mm");
      let dateTimeString = dateTime.format("ddd D MMM gggg h A");
      let updateTime =
        dateTimeString === "Invalid date"
          ? moment().format("ddd D MMM gggg h A")
          : dateTimeString;

      axios
        .put("/carry-freight/bookings/" + id + "/delivered", {
          update_time: updateTime,
        })
        .then((response) => {
          let data = response.data;

          if (data.is_success) {
            this.$swal({
              title: data.message,
              type: "success",
            });

            this.$store.dispatch(LOAD_DASHBOARD_CONSIGNMENTS);
          } else {
            this.$swal({
              title: data.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          Event.$emit("serverError");
          // console.log(error);
        });
    },
    updateETA(id) {
      let dateTime = moment(this.statusDate, "YYYY-MM-DD HH:mm");
      let dateTimeString = dateTime.format("ddd D MMM gggg h A");
      let etaTime =
        dateTimeString === "Invalid date"
          ? moment().format("ddd D MMM gggg h A")
          : dateTimeString;

      axios
        .post("/carry-freight/legs/" + id + "/eta", {
          eta_time: etaTime,
          reason: this.reason,
        })
        .then((response) => {
          let data = response.data;

          if (data.is_success) {
            this.$swal({
              title: data.message,
              type: "success",
            });
            this.isDisabled = false;
            this.$store.dispatch(LOAD_DASHBOARD_CONSIGNMENTS);
          } else {
            this.$swal({
              title: data.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          Event.$emit("serverError");
          // console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.carrier-table {
  min-height: 20rem;
  max-height: 42rem;
}
.with-full-radius {
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
}
.t-bg-red {
  background: #ff0000;
  border-color: #ff0000;
}
.text-error {
  color: #ff0000;
}
</style>
